import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Package } from 'lucide-react';
import TopBar from '../components/common/TopBar';
import BottomNav from '../components/common/BottomNav';
import LoadingSpinner from '../components/common/LoadingSpinner';
import { orderService } from '../services/api';

const statusLabels = {
  created: { text: 'Criado', color: 'bg-muted text-muted-foreground' },
  payment_pending: { text: 'Aguardando pagamento', color: 'bg-yellow-100 text-yellow-800' },
  payment_approved: { text: 'Pago', color: 'bg-secondary/20 text-secondary' },
  received: { text: 'Recebido', color: 'bg-secondary/20 text-secondary' },
  accepted: { text: 'Aceito', color: 'bg-secondary/20 text-secondary' },
  preparing: { text: 'Em preparo', color: 'bg-primary/20 text-primary' },
  out_for_delivery: { text: 'Saiu para entrega', color: 'bg-primary/20 text-primary' },
  delivered: { text: 'Entregue', color: 'bg-secondary text-secondary-foreground' },
  cancelled: { text: 'Cancelado', color: 'bg-destructive/20 text-destructive' },
  expired: { text: 'Expirado', color: 'bg-muted text-muted-foreground' },
};

const Orders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const data = await orderService.list();
      setOrders(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <TopBar title="Meus Pedidos" />
        <LoadingSpinner size="lg" />
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background pb-20" data-testid="orders-page">
      <TopBar title="Meus Pedidos" />

      <div className="max-w-md mx-auto p-4">
        {orders.length === 0 ? (
          <div className="text-center py-12">
            <Package className="w-20 h-20 mx-auto text-muted-foreground mb-4" strokeWidth={1.5} />
            <h2 className="font-['Outfit'] text-xl font-bold mb-2">Nenhum pedido ainda</h2>
            <p className="text-muted-foreground mb-6">Faça seu primeiro pedido!</p>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-primary text-primary-foreground rounded-full font-semibold"
            >
              Explorar quiosques
            </button>
          </div>
        ) : (
          <div className="space-y-3">
            {orders.map((order) => {
              const status = statusLabels[order.status] || statusLabels.created;
              return (
                <button
                  key={order.id}
                  data-testid={`order-${order.id}`}
                  onClick={() => navigate(`/order/${order.id}`)}
                  className="w-full bg-white rounded-xl shadow-sm border border-border p-4 text-left hover:shadow-md transition-shadow active:scale-[0.98]"
                >
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <p className="font-semibold text-foreground">
                        Pedido #{order.order_number?.slice(-6)}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {new Date(order.created_at).toLocaleString('pt-BR')}
                      </p>
                    </div>
                    <ChevronRight className="w-5 h-5 text-muted-foreground" />
                  </div>
                  <div className="flex items-center justify-between mt-3">
                    <span className={`text-xs px-2 py-1 rounded-full font-semibold ${status.color}`}>
                      {status.text}
                    </span>
                    <span className="font-bold text-primary">
                      R$ {order.total.toFixed(2)}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
};

export default Orders;
